// jQuery
jQuery(function ($) {
  $('.gnavBtn').on('click', function () {
    $(this).toggleClass('is-open');
    $('.gnav').toggleClass('is-open');
    var expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !expanded);
    var label = $(this).attr('aria-label') === 'メニューを開く' ? 'メニューを閉じる' : 'メニューを開く';
    $(this).attr('aria-label', label);
    var hidden = $('.gnav').attr('aria-hidden') === 'true';
    $('.gnav').attr('aria-hidden', !hidden);
  });
  $('.gnav a').on('click', function () {
    $('.gnav').removeClass('is-open');
    $('.gnavBtn').removeClass('is-open');
    $('.gnavBtn').attr('aria-expanded', 'false');
    $('.gnavBtn').attr('aria-label', 'メニューを開く');
    $('.gnav').attr('aria-hidden', 'true');
  });

  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $('.totop');

  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });

  // -----------------------------
  // gnavアコーディオン
  // -----------------------------
  if (window.matchMedia("(max-width: 1119px)").matches) {
    $('.js-gnavAccordion').click(function () {
      $(this).next('.js-gnavAccordion-contents').slideToggle();
      $(this).toggleClass("is-open");
    });
  }

  // -----------------------------
  // modal
  // -----------------------------
  // ページが読み込まれたときにURLパラメーターをチェックし、指定されたモーダルを開く
  var urlParams = new URLSearchParams(window.location.search);
  var modalToOpen = urlParams.get('modal');
  if (modalToOpen) {
    $('#' + modalToOpen).fadeIn();
  }

  // クリックされた要素に応じてモーダルを開く
  $('.js-modal-open').each(function () {
    $(this).on('click', function () {
      var target = $(this).data('target');
      $('#' + target).fadeIn();
      return false;
    });
  });

  // モーダルを閉じる
  $('.js-modal-close').on('click', function () {
    $('.js-modal').fadeOut();
    return false;
  });


  // ----------------------------------------
  // ドラッグスクロールをPCでもできるようにする
  // ----------------------------------------
  $.fn.mousedragscrollable = function () {
    let target;

    this.each(function () {
      const $element = $(this);

      $element.on("mousedown", function (event) {
        event.preventDefault();
        target = $element;

        $element.data({
          down: true,
          move: false,
          x: event.clientX,
          y: event.clientY,
          scrollleft: $element.scrollLeft(),
          scrolltop: $element.scrollTop(),
        });

        return false;
      });

      $element.on("click", function () {
        if ($element.data("move")) {
          return false;
        }
      });
    });

    $(document)
      .on("mousemove", function (event) {
        if (!target || !target.data("down")) {
          return;
        }

        event.preventDefault();

        const moveX = target.data("x") - event.clientX;
        const moveY = target.data("y") - event.clientY;

        if (moveX === 0 && moveY === 0) {
          return;
        }

        target.data("move", true);
        target.scrollLeft(target.data("scrollleft") + moveX);
        target.scrollTop(target.data("scrolltop") + moveY);

        return false;
      })
      .on("mouseup", function () {
        if (target) {
          target.data("down", false);
        }
      });

    return this;
  };

  $(".drag-scroll").mousedragscrollable();
});


// -----------------------------
// お問い合わせボタン
// -----------------------------
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-contact-product").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      window.location.href = el.getAttribute("href") + "?type=product";
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);

  if (params.get("type") === "product") {
    const select = document.querySelector('select[name="your-subject"]');
    if (select) {
      const option = Array.from(select.options).find(opt => opt.text.trim() === "製品について");
      if (option) {
        select.value = option.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }
});


// -----------------------------
// スクロールヒント
// -----------------------------
new ScrollHint('.js-scroll', {
  scrollHintIconAppendClass: "scroll-hint-icon-white",
  // applyToParents: true,
  i18n: {
    scrollable: 'スクロールできます'
  }
});


// -----------------------------
// 改行でspanを生成
// -----------------------------
document.addEventListener("DOMContentLoaded", function () {
  let paragraphs = document.querySelectorAll(".js-span");
  paragraphs.forEach(p => {
    let html = p.innerHTML;
    let lines = html.split('<br>');
    let newHtml = lines.map((line, index) => {
      // 最後の行には <br> を追加しない
      return index === lines.length - 1 ? `<span>${line}</span>` : `<span>${line}</span><br>`;
    }).join('');
    p.innerHTML = newHtml;
  });
});

// -----------------------------
// 購入フォームの計算
// -----------------------------
// -----------------------------
// 購入フォームの計算
// -----------------------------
document.addEventListener("DOMContentLoaded", function () {
  const pref = document.querySelector(".js-pref"); // 都道府県
  const pieces = document.querySelector(".js-pieces"); // 購入数
  const total = document.querySelector(".js-total"); // 合計金額

  const price = 3960; // 商品代金
  const cool = 330; // クール便手数料
  const cash = 330; // 代引手数料

  const priceTotal = document.querySelector(".js-total-price"); // 商品代金合計
  const postageTotal = document.querySelector(".js-total-postage"); // 都道府県送料合計
  const coolTotal = document.querySelector(".js-total-cool"); // クール便手数料合計
  const cashTotal = document.querySelector(".js-total-cash"); // 代引手数料合計
  const postageInput = document.querySelector(".js-postage"); // 都道府県送料

  if (!pieces || !pref || !total) return;

  function getPostage(prefValue) {
    prefValue = prefValue.trim();

    if (prefValue === "北海道") {
      return 2050;
    }

    if (["青森県", "秋田県", "岩手県"].includes(prefValue)) {
      return 1650;
    }

    if (["群馬県"].includes(prefValue)) {
      return 1410;
    }

    if ([
      "宮城県", "山形県", "福島県",
      "茨城県", "栃木県", "埼玉県", "千葉県", "神奈川県", "東京都", "山梨県",
      "新潟県", "長野県",
      "富山県", "石川県", "福井県",
      "静岡県", "愛知県", "三重県", "岐阜県"
    ].includes(prefValue)) {
      return 1530;
    }

    if (["大阪府", "京都府", "滋賀県", "奈良県", "和歌山県", "兵庫県"].includes(prefValue)) {
      return 1650;
    }

    if ([
      "岡山県", "広島県", "山口県", "鳥取県", "島根県",
      "香川県", "徳島県", "愛媛県", "高知県"
    ].includes(prefValue)) {
      return 1790;
    }

    if (["福岡県", "佐賀県", "長崎県", "熊本県", "大分県", "宮崎県", "鹿児島県"].includes(prefValue)) {
      return 2050;
    }

    if (prefValue === "沖縄県") {
      return 2710;
    }

    return 0;
  }

  function calculateTotal() {
    // 半角数字のみ
    if (!String(pieces.value).match(/^\d+$/)) {
      pieces.value = "";
    }

    const quantity = Number(pieces.value || 0);
    const postage = getPostage(pref.value);

    if (postageInput) {
      postageInput.value = postage;
    }

    if (priceTotal) {
      priceTotal.value = price * quantity;
    }

    if (postageTotal) {
      postageTotal.value = postage * quantity;
    }

    if (coolTotal) {
      coolTotal.value = cool * quantity;
    }

    if (cashTotal) {
      cashTotal.value = cash * quantity;
    }

    total.value = (price + postage + cool + cash) * quantity;
  }

  // 購入数を変えた時
  pieces.addEventListener("input", calculateTotal);
  pieces.addEventListener("change", calculateTotal);

  // 都道府県を直接入力した時
  pref.addEventListener("input", calculateTotal);
  pref.addEventListener("change", calculateTotal);
  pref.addEventListener("blur", calculateTotal);

  // 郵便番号自動入力などで pref.value だけ変わるケース対策
  let currentPrefValue = pref.value;

  setInterval(function () {
    if (pref.value !== currentPrefValue) {
      currentPrefValue = pref.value;
      calculateTotal();
    }
  }, 300);

  calculateTotal();
});

// document.addEventListener("DOMContentLoaded", function () {
//   const pref = document.querySelector(".js-pref"); // 都道府県
//   const pieces = document.querySelector(".js-pieces"); // 購入数
//   const total = document.querySelector(".js-total"); // 合計金額

//   const price = 3960; // 商品代金
//   const cool = 330; // クール便手数料
//   const cash = 330; // 代引手数料

//   const priceTotal = document.querySelector(".js-total-price"); // 商品代金合計
//   const postageTotal = document.querySelector(".js-total-postage"); // 都道府県送料合計
//   const coolTotal = document.querySelector(".js-total-cool"); // クール便手数料合計
//   const cashTotal = document.querySelector(".js-total-cash"); // 代引手数料合計
//   const postageInput = document.querySelector(".js-postage"); // 都道府県送料

//   if (!pieces || !pref || !total) return;

//   function getPostage(prefValue) {
//     if (prefValue === "北海道") {
//       return 2050;
//     }

//     if (["青森県", "秋田県", "岩手県"].includes(prefValue)) {
//       return 1650;
//     }

//     if ([
//       "宮城県", "山形県", "福島県",
//       "茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "神奈川県", "東京都", "山梨県",
//       "新潟県", "長野県",
//       "富山県", "石川県", "福井県",
//       "静岡県", "愛知県", "三重県", "岐阜県"
//     ].includes(prefValue)) {
//       return 1530;
//     }

//     if (["大阪府", "京都府", "滋賀県", "奈良県", "和歌山県", "兵庫県"].includes(prefValue)) {
//       return 1650;
//     }

//     if ([
//       "岡山県", "広島県", "山口県", "鳥取県", "島根県",
//       "香川県", "徳島県", "愛媛県", "高知県"
//     ].includes(prefValue)) {
//       return 1790;
//     }

//     if (["福岡県", "佐賀県", "長崎県", "熊本県", "大分県", "宮崎県", "鹿児島県"].includes(prefValue)) {
//       return 2050;
//     }

//     if (prefValue === "沖縄県") {
//       return 2710;
//     }

//     return 0;
//   }

//   function calculateTotal() {
//     // 半角数字のみ
//     if (!String(pieces.value).match(/^\d+$/)) {
//       pieces.value = "";
//     }

//     const quantity = Number(pieces.value || 0);
//     const postage = getPostage(pref.value);

//     if (postageInput) {
//       postageInput.value = postage;
//     }

//     priceTotal.value = price * quantity;
//     postageTotal.value = postage * quantity;
//     coolTotal.value = cool * quantity;
//     cashTotal.value = cash * quantity;

//     const fee = (price + postage + cool + cash) * quantity;

//     total.value = fee;
//   }

//   pieces.addEventListener("change", calculateTotal);
//   pref.addEventListener("change", calculateTotal);
// });

// -----------------------------
// アニメーション
// -----------------------------
// 到達したら要素を表示させる　フェードイン
function showElementAnimation() {

  var element = document.getElementsByClassName('js-animation');
  if (!element) return; // 要素がなかったら処理をキャンセル

  var showTiming = window.innerHeight > 768 ? 320 : 40; // 要素が出てくるタイミングはここで調整
  var scrollY = window.pageYOffset;
  var windowH = window.innerHeight;

  for (var i = 0; i < element.length; i++) {
    var elemClientRect = element[i].getBoundingClientRect();
    var elemY = scrollY + elemClientRect.top;
    if (scrollY + windowH - showTiming > elemY) {
      element[i].classList.add('is-show');
    } else if (scrollY + windowH < elemY) {
      // 上にスクロールして再度非表示にする場合はこちらを記述
      // element[i].classList.remove('is-show');
    }
  }
}
showElementAnimation();
window.addEventListener('scroll', showElementAnimation);


const image = document.querySelectorAll('.js-parallax');
new simpleParallax(image, {
  overflow: !0,
  delay: .6,
  orientation: "down"
});


// -----------------------------
// wave canvas
// -----------------------------
var unit = 100,
  canvasList, // キャンバスの配列
  info = {}, // 全キャンバス共通の描画情報
  colorList; // 各キャンバスの色情報

/**
 * Init function.
 *
 * Initialize variables and begin the animation.
 */
function init() {
  info.seconds = 0;
  info.t = 0;
  canvasList = [];
  colorList = [];

  // canvas1個めの色指定
  const waveCanvas = document.getElementById("waveCanvas");
  if (waveCanvas) {
    canvasList.push(waveCanvas);
    colorList.push(["#187FC4"]);
  }

  // 波B（グラデーション）
  const gradientCanvases = document.querySelectorAll(".waveCanvasGradient");
  gradientCanvases.forEach((gradientCanvas) => {
    canvasList.push(gradientCanvas);
    colorList.push(["gradient"]);
  });

  // 各キャンバスの初期化
  for (var canvasIndex in canvasList) {
    var canvas = canvasList[canvasIndex];
    canvas.width = document.documentElement.clientWidth; //Canvasのwidthをウィンドウの幅に合わせる
    canvas.height = 90; //波の高さ
    canvas.contextCache = canvas.getContext("2d");
  }
  // 共通の更新処理呼び出し
  update();
}

function update() {
  for (var canvasIndex in canvasList) {
    var canvas = canvasList[canvasIndex];
    // 各キャンバスの描画
    draw(canvas, colorList[canvasIndex]);
  }
  // 共通の描画情報の更新
  info.seconds = info.seconds + 0.010;
  // info.seconds = info.seconds + 0.014;
  info.t = info.seconds * Math.PI;
  // 自身の再起呼び出し
  setTimeout(update, 35);
}

/**
 * Draw animation function.
 *
 * This function draws one frame of the animation, waits 20ms, and then calls
 * itself again.
 */
function draw(canvas, color) {
  var context = canvas.contextCache;
  context.clearRect(0, 0, canvas.width, canvas.height);

  if (color[0] === "gradient") {
    var gradient = context.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop(0, "#00cf88");
    gradient.addColorStop(1, "#4aaee5");
    drawWave(canvas, gradient, 0.6, 2.5, 1);
  } else {
    drawWave(canvas, color[0], 1, 3, 0);
  }
}

/**
 * 波を描画
 * drawWave(色, 不透明度, 波の幅のzoom, 波の開始位置の遅れ)
 */
function drawWave(canvas, color, alpha, zoom, delay) {
  var context = canvas.contextCache;
  context.strokeStyle = color; // 線の色
  context.globalAlpha = alpha;
  context.lineWidth = 3; // 線の太さ
  context.beginPath(); // パスの開始
  drawSine(canvas, info.t / 0.5, zoom, delay);
  context.stroke(); // 線を描画
}

/**
 * Function to draw sine
 *
 * The sine curve is drawn in 10px segments starting at the origin.
 * drawSine(時間, 波の幅のzoom, 波の開始位置の遅れ)
 */
function drawSine(canvas, t, zoom, delay) {
  var xAxis = Math.floor(canvas.height / 2);
  var yAxis = 0;
  var context = canvas.contextCache;
  // Set the initial x and y, starting at 0,0 and translating to the origin on
  // the canvas.
  var x = t; //時間を横の位置とする
  var y = Math.sin(x) / zoom;
  context.moveTo(yAxis, unit * y + xAxis); //スタート位置にパスを置く

  // Loop to draw segments (横幅の分、波を描画)
  for (i = yAxis; i <= canvas.width + 10; i += 10) {
    x = t + (-yAxis + i) / unit / zoom;
    y = Math.sin(x - delay) / 3;
    context.lineTo(i, unit * y + xAxis);
  }
}

init();


// -----------------------------
// ローディングアニメーション
// -----------------------------
function loadedPage() {
  const loadingID = document.getElementById("js-loading");
  if (loadingID) loadingID.classList.add("is-loaded");
}

function hideLoading() {
  const loadingID = document.getElementById("js-loading");
  if (!loadingID) return;

  loadingID.classList.add("is-loaded");
  loadingID.style.display = "none";
}

window.addEventListener("load", function () {
  const loadingID = document.getElementById("js-loading");
  if (!loadingID) return;

  const KEY = "top_loading_played";

  // このタブで最初の1回だけ再生
  if (!sessionStorage.getItem(KEY)) {
    sessionStorage.setItem(KEY, "1");
    setTimeout(loadedPage, 16000);
  } else {
    hideLoading();
  }

  const skip = document.querySelector(".js-skip");
  if (skip) {
    skip.addEventListener("click", () => {
      loadingID.classList.add("is-loaded");
    });
  }
});

// 戻る / 進む のキャッシュ復元時はローディングを出さない
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    hideLoading();
  }
});
